import { defineStore } from 'pinia'
import { useQuery } from '@vue/apollo-composable'
import { READ_CHAT_LOCALIZATION_TEXT_JSON } from '@/graphql/mia/queries/readChatLocalization'
import { LocaleMessageDictionary, useI18n, VueMessageType } from 'vue-i18n'
import { LanguageEnum, QueryReadChatLocalizationTextJsonArgs } from '@/generated/graphql.mia'
import { computed } from 'vue'
import { defaultLanguage } from '@/composables/useCustomParams'

export const useLocaleStore = defineStore('localeStore', () => {
  const i18n = useI18n()

  const readChatLocalizationTextJsonVars = computed(() => ({
    localizationTextInput: {
      languageEnum: i18n.locale.value.toLocaleUpperCase() as LanguageEnum
    }
  }))

  const { onResult: onReadChatLocalizationTextJsonResult, onError: onReadChatLocalizationTextJsonError } = useQuery<
    { readChatLocalizationTextJson: LocaleMessageDictionary<VueMessageType> },
    QueryReadChatLocalizationTextJsonArgs
  >(READ_CHAT_LOCALIZATION_TEXT_JSON, readChatLocalizationTextJsonVars, {
    clientId: 'mia'
  })

  onReadChatLocalizationTextJsonResult(res => {
    if (!res.loading) {
      i18n.setLocaleMessage(i18n.locale.value, res.data.readChatLocalizationTextJson)
    }
  })

  onReadChatLocalizationTextJsonError(() => {
    const lang = defaultLanguage.toLocaleLowerCase()
    console.error(`Unable to fetch "${i18n.locale.value}" locale. Setting ${lang} instead.`)
    i18n.locale.value = lang
  })
})
